var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1.0009765625em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "path{fill:#5c03ec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.604486 0C229.704841 0 0 228.495868 0 511.395514s229.704841 512.604486 512.604486 512.604486 512.604486-229.704841 512.604487-512.604486C1024 228.495868 795.504132 0 512.604486 0z m0 898.266824c-213.988194 0-386.871311-172.883117-386.87131-386.87131s172.883117-386.871311 386.87131-386.871311 386.871311 172.883117 386.871311 386.871311-174.09209 386.871311-386.871311 386.87131z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.988808 824.507391l703.549657-703.561748 92.329256 92.329257-703.561747 703.549657z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectionsIcon);
export default __webpack_public_path__ + "static/media/rejections-icon.65499031bb78d181bfa0a7ff3f29dbad.svg";
export { ForwardRef as ReactComponent };